<template>
    <data-table
        action-button-text="مقاله جدید"
        action-button-icon="add"
        additional-action-button-text="مرتب سازی"
        additional-action-button-icon="icon-transfer"
        show-select
        remove-key="knowledgeBaseArticle"
        export-key="knowledgeBaseArticles"
        settings-key="knowledgeBaseArticles"
        @click:additionalActionButton="sortDialogRef.openDialog()"
        @click:actionButton="createArticle"
        @getList="getList"
        @deleted="system.setKbParentCategories();"
        ref="dataTableRef"
        :rowClick="(row) => router.resolve({path: `/knowledgeBaseArticles/${row.id}`})"
        :headers="headers"
        :items="items"
        :loading="loading"
        :totalItems="totalItems"
        :filters="filters"
        :getAllList="getAllList"
    ></data-table>
    <sort-dialog ref="sortDialogRef" @updated="getList(dataTableRef.finalFilters)" type="knowledgeBaseArticle"></sort-dialog>
</template>
<script setup>
import { useApi } from '@/plugins/api';
import { useSystemStore } from '@/stores/system';
import { onBeforeMount } from 'vue';
import { useTemplateRef } from 'vue';
import { useRouter } from 'vue-router';

defineOptions({
    title: "مقالات پایگاه دانش",
    validate(context) {
        return context.system.license.features.kb_core && context.rbac.can('manage knowledge base');
    },
})
const api = useApi();
const moment = useMoment();
const router = useRouter();
const system = useSystemStore();
const sortDialogRef = useTemplateRef('sortDialogRef');
const dataTableRef = useTemplateRef('dataTableRef');
const loading = ref(false);
const items = ref([]);
const totalItems = ref(0);
const headers = ref([
    {
        title: 'عنوان',
        key: 'name',
        value: (item) => item.name,
        minWidth: 220,
    },
    {
        title: 'دسته‌بندی',
        key: 'category',
        value: (item) => system.kbArticleCategories.length ? system.kbArticleCategories.find(x => x.id == item.knowledge_base_category_id).name : undefined,
        minWidth: 270,
    },
    {
        title: 'دسترسی',
        key: 'public',
        value: (item) => item.public ? 'عمومی' : 'خصوصی',
        minWidth: 160,
    },
    {
        title: 'کاربران',
        key: 'user_group',
        value: (item) => item.user_group == 'employees' ? 'کاربران سازمانی' : item.user_group == 'customers' ? 'مشتریان' : 'مشتریان و کاربران سازمانی',
        minWidth: 180,
    },
    {
        title: 'تعداد بازدید',
        key: 'views',
        value: (item) => item.views,
        minWidth: 180,
    },
    {
        title: 'وضعيت',
        key: 'publishStatus',
        value: (item) => item.status == 'draft' ? 'پیش نویس' : 'منتشر شده',
        minWidth: 150,
    },
    {
        title: 'زمان مطالعه',
        key: 'read_time',
        value: (item) => item.read_time,
        minWidth: 200,
    },
    {
        title: 'نظر مثبت',
        key: 'likes',
        value: (item) => item.likes,
        minWidth: 150,
    },
    {
        title: 'نظر منفي',
        key: 'dislikes',
        value: (item) => item.dislikes,
        minWidth: 150,
    },
    {
        title: 'تاريخ ايجاد',
        key: 'created_at',
        cellProps: {style: 'direction: ltr; text-align: right'},
        value: (item) => item.created_at ? moment(item.created_at).format('jYYYY/jMM/jDD | HH:mm') : undefined,
        minWidth: 150,
    },
    {
        title: 'آخرين بروزرساني',
        key: 'updated_date',
        cellProps: {style: 'direction: ltr; text-align: right'},
        value: (item) => item.updated_date ? moment(item.updated_date).format('jYYYY/jMM/jDD | HH:mm') : undefined,
        minWidth: 150,
    },
]);
const filters = ref({
    page: { type: 'hidden', label: 'صفحه', value: 1 },
    perPage: { type: 'hidden', label: 'تعداد آیتم در صفحه', value: 10 },
    keyword_based: { type: 'divider', label: 'بر اساس عنوان', value: null },
    name: { type: 'text', label: 'عنوان', value: null },
    features_based: { type: 'divider', label: 'بر اساس ویژگی‌ها', value: null },
    knowledge_base_category_ids: { type: 'autocomplete', multiple: true, label: 'دسته‌بندی', items: [], value: [] },
    public: { type: 'autocomplete', label: 'دسترسی', items: [{ name: 'عمومی', id: '1' },{ name: 'خصوصی', id: '0' }], value: null },
    user_group: { type: 'autocomplete', label: 'کاربران', items: [{ name: 'کاربران سازمانی', id: 'employees' },{ name: 'مشتریان', id: 'customers' },{ name: 'کاربران سازمانی و مشتریان', id: 'both' }], value: null },
    status_based: { type: 'divider', label: 'بر اساس وضعیت', value: null },
    status: { type: 'autocomplete', label: 'وضعیت', items: [{name:'انتشار یافته',id:'published'},{name:'پیش‌ نویس',id:'draft'}], value: null },
    date_based: { type: 'divider', label: 'بر اساس تاریخ', value: null },
    from_date: { type: 'date', label: 'تاریخ ایجاد', group: 'start', onChange: (value) => { filters.value.to_date.value = value > filters.value.to_date.value ? null : filters.value.to_date.value; filters.value.to_date.min = value; }, value: null },
    to_date: { type: 'date', label: 'تاریخ ایجاد', group: 'end', min: null, value: null },
    from_updated_date: { type: 'date', label: 'تاریخ بروزرسانی', group: 'start', onChange: (value) => { filters.value.to_updated_date.value = value > filters.value.to_updated_date.value ? null : filters.value.to_updated_date.value; filters.value.to_updated_date.min = value; }, value: null },
    to_updated_date: { type: 'date', label: 'تاریخ بروزرسانی', group: 'end', min: null, value: null },
})
async function createArticle() {
    let res = await api.knowledgebaseArticleStore();
    if (res && res.status == 'CREATED')
        router.push({path: `/knowledgeBaseArticles/${res.data.id}`});
}
async function getList(finalFilters, cb = false) {
    loading.value = true;
    await api.knowledgebaseArticleList(finalFilters).then(async res => {
        if (res && res.status == "OK") {
            items.value = res.data;
            totalItems.value = res.total;
        }
    }).finally(() => loading.value = false);
    if (cb)
        cb();
}
async function getAllList(finalFilters) {
    let page = 1, data = [];
    while (page) {
        await api.knowledgebaseArticleList({
            ...finalFilters,
            perPage: 200,
            page: page,
        }).then(async res => {
            if (res && res.status == "OK") {
                data = data.concat(res.data);
                page = page == res.totalPages ? false : page + 1
            } else
                page = false;
        }).catch(() => page = false);
    }
    return data;
}
onBeforeMount(() => {
    system.setKbParentCategories().then(() => { filters.value.knowledge_base_category_ids.items = system.kbArticleCategories });
})
</script>
